class OiAccordion {
    private readonly accordionToggle: HTMLButtonElement;
    private readonly accordionContent: HTMLElement;
    private readonly accordionTitle: HTMLElement;
    private readonly accordionHash: string;

    constructor(private readonly oiAccordion: HTMLElement) {
        this.accordionToggle = oiAccordion.querySelector('button.accordion-toggle') as HTMLButtonElement;
        this.accordionContent = oiAccordion.querySelector('.accordion-content') as HTMLElement;
        this.accordionTitle = oiAccordion.querySelector('.accordion-title') as HTMLElement;
        this.accordionHash = `#${oiAccordion.dataset.hash}`;

        this.init();
    }

    private init() {
        this.accordionTitle.addEventListener('click', this.handleToggle.bind(this));
        this.accordionToggle.addEventListener('click', this.handleToggle.bind(this));
        this.accordionContent.style.height = '0px';
        this.accordionContent.style.opacity = '0';

        this.overrideHistoryMethods();
        window.addEventListener('urlchange', this.handleUrlChange.bind(this));
        window.addEventListener('popstate', () => window.dispatchEvent(new Event('urlchange')));

        this.handleUrlChange(new Event('urlchange')); // Check the URL on load
    }

    private overrideHistoryMethods() {
        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;

        const urlChangeEvent = () => window.dispatchEvent(new Event('urlchange'));

        history.pushState = function(...args) {
            originalPushState.apply(this, args);
            urlChangeEvent();
        };

        history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            urlChangeEvent();
        };
    }

    private handleToggle(e:Event) {
        e.preventDefault();
        const hash = window.location.hash;

        if(this.oiAccordion.classList.contains('open')) {
            console.log('open');
            this.closeAccordion();
            if(hash == this.accordionHash) {
                this.removeHashFromUrl();
            }
        } else {
            console.log('close');
            this.openAccordion();
            this.removeHashFromUrl();
            hash != this.accordionHash ? this.addHashToUrl() : {};
        }
    }

    private handleUrlChange(e: Event) {
        e.preventDefault();
        window.location.hash === this.accordionHash ? this.openAccordion() : null;
    }

    private addHashToUrl() {
        const hashUrl = window.location.href + this.accordionHash;
        history.pushState(null, '', hashUrl);
    }

    private removeHashFromUrl() {
        const cleanUrl = window.location.origin + window.location.pathname + window.location.search;
        history.pushState(null, '', cleanUrl);
    }

    private openAccordion() {
        this.oiAccordion.classList.add('open');
        this.accordionContent.style.height = `${this.accordionContent.scrollHeight}px`;
        this.accordionContent.style.opacity = '1';

        this.accordionContent.addEventListener('transitionend', this.resetHeight.bind(this), { once: true });
    }

    private closeAccordion() {
        this.accordionContent.style.height = `${this.accordionContent.scrollHeight}px`;
        this.accordionContent.offsetHeight; // Force reflow for the transition
        this.accordionContent.style.height = '0px';
        this.accordionContent.style.opacity = '0';
        this.oiAccordion.classList.remove('open');
    }

    private resetHeight() {
        if (this.oiAccordion.classList.contains('open')) {
            this.accordionContent.style.height = 'auto';
        }
    }
}

export default OiAccordion;